export const SHOP_ID = import.meta.env.VITE_SHOP_ID || '1'
export const BRAND_ID = import.meta.env.VITE_HIVE_BRAND_ID || '1'

export * from './app'
export * from './contacts'
export * from './cookie-keys'
export * from './navigation'
export * from './order-statuses'
export * from './payment-types'
export * from './patterns'
export * from './payments'
export * from './query'
export * from './social'
export * from './image-sizes'
export * from './routes'